export default "__VITE_ASSET__BzXlcMkq__"